import { ShopperProducts } from "commerce-api"

export const getSecureImageUrl = (image: ShopperProducts.Image) => {
  if (!image) return ''
  if (image?.dis_base_link) {
    return `${image.dis_base_link.replace('http:', 'https:')}?&fmt=auto`
  } else if (image?.disBaseLink) {
    return `${image.disBaseLink.replace('http:', 'https:')}?&fmt=auto`
  }
  return ''
}